import React from "react";
import styles from "./text.module.css";

export default function Typography({
  variant,
  className = "",
  children,
  ...props
}) {
  const classes = `${styles[variant] || ""}    ${className}`.trim();
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
